import React, { useState,useEffect,useCallback } from "react";
import api from "views/auth/Api";
import { Link } from "react-router-dom";
import "../training.css"
import { useParams } from 'react-router-dom';
import { GoPlay } from "react-icons/go";
import { BiSkipNextCircle } from "react-icons/bi";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import McqQuiz from "./McqQuiz";

const TrainingField = () => {
  const [resources , setResources] = useState([]);
  const [trainingData , setTrainingData] = useState();
  const [selected , setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [open , setOpen] = useState(false)
 
    const fetchVideos = useCallback( async () => {
    try {
      const res = await api.get(`${API_BASE_URL}training-resources/training/${id}`);
      setResources(res.data?.videosWithUnlocks);
      setTrainingData(res.data?.training);
      // if selected becomes locked (after refresh), unset it
      if (selected) {
        const stillAllowed = res.data?.videosWithUnlocks.find(v => v.id === selected.id)?.unlocked;
        if (!stillAllowed) setSelected(null);
      }
    } catch (err) {
      console.error(err);
    }
  }, [id, selected]);


  useEffect(()=>{ 
  fetchVideos();  
  },[fetchVideos]);
   
    const handleComplete = async (videoId) => {
    try {
      setLoading(true);
     const res = await api.post(`${API_BASE_URL}training-progress/complete`, {videoId });
      const nextVideoId = res.data.nextVideoId;
      setSelected(res.data);
      await fetchVideos();
        if (nextVideoId) {
        const nextVideo = resources.find(v => v.id === nextVideoId);
        console.log(nextVideo, "nextVideo");
        if (nextVideo) setSelected(nextVideo);
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
const totalVideos = resources.length;
const watchedCount = resources.filter(p => p.completed).length;
const progressPercentage = totalVideos === 0 ? 0 : Math.round((watchedCount / totalVideos) * 100);

const scrollToTop = (video) => {
  if (video.completed || video.unlocked) {
    window.scrollTo({
      top: 120,
      behavior: 'smooth', // smooth scroll
    });
    }
    else return
  };
const scrollToComplete =() => {
window.scrollTo({
      top: 120,
      behavior: 'smooth', // smooth scroll
    });
    }
const scrollToQuiz =() => {
   const bottom = document.documentElement.scrollHeight;
window.scrollTo({
      top: bottom,
      behavior: 'smooth', // smooth scroll
    });
    }
  const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}


  return (
    <div className="">
      <div className="field-header">
         <div className="fieldImg"></div>
          <div className="field-h">
            <h2>{trainingData?.name}</h2>
            <div className="completed">
                <span>{progressPercentage}% &nbsp; Completed</span>
                <div class="field-container">
                    <div class="field-bar" style={{ width: `${progressPercentage}%` }}></div>
                 </div>
            </div>
          </div>
      </div>
      <div style={{ flex: 1 }}>
        {selected ? (
            <div className="videoFrame">
            <h3 className="videoName">{selected.title}</h3>
            <iframe
              key={selected.id}
              src={selected.url}
              style={{ border: 0, width: "95%", height: "700px", borderRadius: "25px", marginBottom: "20px", alignItems: "center" }}
              allowFullScreen
              allow="encrypted-media"
              title="VdoCipher Video"> </iframe>
            {loading && <div>Saving progress...</div>}
           {!selected.completed ? <button className="markComplete"
            onClick={() => {handleComplete(selected.id)
              scrollToComplete();
            }}>Mark as Complete 
            <IoCheckmarkDoneCircleOutline className="doneImgHover"/></button> : null}
          </div>
        ) : (
          <div style={{marginBottom: "20px"}}>
            {/* <h3>No video selected</h3>
            <p>Select an unlocked video to start watching.</p> */}
          </div>
        )}
      </div>
        {/* Course Overview */}
        <div className="courseFlex">
        <div className="courseLayout">
            <div className="courseOverview">
              <div className="trainingCover" style={{backgroundImage:`url(${FILES_URL}${trainingData?.cover?.url})`}}></div>
              <div className="flex justify-between">
              <div>
                <h4>Course Overview</h4>
                <p><MyComponent htmlContent={trainingData?.overview}/>      
                </p>
                </div>
                <button disabled={progressPercentage < 100} onClick={() => {setOpen(true);
                scrollToQuiz();
               }} 
               className={progressPercentage < 100 ? "quizNoActive" : "btn-Quiz"}>Start Quiz</button>
               </div>
            </div>
            <div className="courseCards">
              {resources.map(video =>
            <div className="course-view" key={video.id}
            style={{ cursor: video.unlocked ? 'pointer' : video.completed ? 'pointer' : 'not-allowed'}}
            onClick={() => {video.unlocked && setSelected(video)
            scrollToTop(video);
            }}>
            <div className="playImg"></div>
            {/* {video.order} */}
                <p>{video.title} </p>
                
                {video.completed ? <IoCheckmarkDoneCircleOutline className="doneImg" style={{ color: "rgb(4, 202, 4)" }}/>
                 : video.unlocked ? <GoPlay className="doneImg" style={{ color: "#573995" }}/> 
                 : <BiSkipNextCircle className="doneImg" style={{ color: "#4a4a4aae" }}/>}
                {/* <button onClick={() => handleComplete(video.id)}>Mark as Complete</button> */}
              </div>
          )}
          </div>
        </div>
        </div>
      {open ?  <McqQuiz questions={trainingData.mcqTraining} trainingId={trainingData.id}/> : null}
    </div>
  );
};

export default TrainingField;
